"use client";
import Link from "next/link";
import "./serviceCard.scss";
import Image from "next/image";
import { useIntl } from "react-intl";

export default function ServiceCard({ service }) {
  const intl = useIntl();

  const openModal = () => {
    // Modal implementation can be added here if needed
  };

  return (
    <div
      // href={`${service?.link}`}
      className="serviceContainer hover:shadow-lg transition-all duration-300"
      style={{
        background: "e3f8ff82",

        // height: '250px',
        // maxHeight: service["id"] == 3 || service["id"] == 4 ? "250px" : "200px",
      }}
    >
      <div className="serviceImgContainer">
        <Image
          src={service?.img?.url}
          alt="care screen banner background"
          fill
          style={{ objectFit: "cover" }}
          sizes="auto"
          loading="lazy"
          className="h-[220px] w-[220px]"
        />
      </div>
      <div className="serviceInfoContainer">
        <p className={"serviceNameType2"}>
          {service?.attributes?.title || service?.attributes?.name || service?.name}
        </p>
        <p className="heading">
          {service?.attributes?.headline ||
          service?.headline ||
          service?.attributes?.description ||
          service?.attributes?.subtitle ||
          service?.heading ||
          service?.subHeading ||
          "Service Details"}
        </p>

        <div className="serviceBtnContainer">
          {service?.link ? (
            <Link href={`/treatments/${service?.link}`} className="serviceBtn">
              {intl.formatMessage({ id: "explore" })}
            </Link>
          ) : (
            <p className="serviceBtn" onClick={openModal}>
              {intl.formatMessage({ id: "explore" })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
